import { Box, FormControl, Select } from '@mui/material';
import React from 'react'

export default function RequireSelect({ value, onChange, menu, disabled, error, setError, textError }) {
    return (
        <>
            <Box className={`backgroundField ${error ? 'error' : ''}`} >
                <FormControl variant="standard" fullWidth disabled={disabled}>
                    <Select value={value || ''}
                        onChange={e => onChange(e.target.value)}
                        disableUnderline
                        onBlur={e => {
                            if (!e.target.value && setError) {
                                setError(true)
                            } else {
                                setError(false)
                            }
                        }}
                        MenuProps={{
                            style: {
                                maxHeight: 400,
                            },
                        }}>
                        {menu}
                    </Select>
                </FormControl>
            </Box>
            {error && <span style={{ color: 'red', fontSize: '12px', }}>{textError}</span>}

        </>
    )
}
